import { Alert } from '@/global/components/Alert'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useCredenciaisApiOutletContext } from 'pages/CredenciaisApi'
import { useNavigate, useParams } from 'react-router-dom'
import { apiClients } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirCredencial() {
    const { id } = useParams()
    const navigate = useNavigate()
    const { data } = useCredenciaisApiOutletContext()
    const credencial = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = apiClients.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!credencial) return null

    const handleClose = () => {
        navigate('/integracoes/credenciais-api')
    }

    const handleSubmit = async () => {
        try {
            await mutateAsync(credencial.id)
            toast.success('Credencial excluída com sucesso')
            handleClose()
        } catch (err: any) {
            toast.error(err?.message || 'Erro ao excluir credencial')
        }
    }

    return (
        <Dialog.Root
            width="md"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'CredenciaisDeAPI'])}
            onClose={handleClose}
        >
            <Dialog.Title action="Excluir credencial de API">
                {credencial.nome}
            </Dialog.Title>
            <Dialog.Content>
                <p className="text-sm text-foreground">
                    Realmente deseja excluir a credencial{' '}
                    <strong>{credencial.nome}</strong> ({credencial.clientId})?
                </p>
                <Alert severity="error" className="mt-3">
                    O acesso de todas as integrações que utilizam esta
                    credencial será revogado e interrompido no próximo request.
                </Alert>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton onClick={handleClose} />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
